<div *ngIf="loading" class="loading-indicator">Loading...</div>
<div *ngIf="!loading">
  <!-- Your existing login form or content goes here -->
</div>
